export const KYE_PREVIEW_VERSION = 'KYE_PERVIEW_VERSION_'

// 不能预览的类型
export const NO_PREVIEWS_LIST = [
  'text',
  'xml',
  'zip',
  'mp3',
  'aac',
  'mp4',
  'wav',
  'v3',
  'heic',
  'xmind',
  'mmap',
  'rar'
]

export const IMG_KEYS = ['png', 'jpg', 'jpeg', 'bmp', 'webp', 'gif', 'svg']



// WEBPACK FOOTER //
// ./src/public/components/kye-preview/component/preview-wrapper/constant.js